import React, { useState } from 'react';
import { ToastContainer, toast } from "react-toastify";

import axios from 'axios';
import { WEB_BASE_URL } from '../unified/webbase';
import cookie from 'react-cookies';

function MerchantKYC() {
  const [formData, setFormData] = useState({
    certificate: '',
    nin: '',
    file: null
  });
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        toast.error('Please upload a valid image (JPEG, PNG) or PDF file');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('File size should not exceed 5MB');
        return;
      }

      setFormData(prev => ({
        ...prev,
        file: file
      }));

      // Create preview URL for images
      if (file.type.startsWith('image/')) {
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
      } else {
        setPreviewUrl(null);
      }
    }
  };

  const handleSubmit = async (e) => {
    const id = toast.loading("Please wait...");
    e.preventDefault();
    
    // Validate form
    if (!formData.certificate.trim()) {
      toast.update(id, {
        render: 'Please enter your certificate name',
        type: 'error'
      });
      return;
    }
    if (!formData.nin.trim()) {
      toast.update(id, {
        render: 'Please enter your NIN',
        type: 'error'
      });
      return;
    }
    if (!formData.file) {
        toast.update(id, {
        render: 'Please upload a file',
        type: 'error'
      });
      return;
    }

    setLoading(true);
    const token = cookie.load('token');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('certificate', formData.certificate);
      formDataToSend.append('nin', formData.nin);
      formDataToSend.append('file', formData.file);

      const response = await axios.post(`${WEB_BASE_URL}/onboarding/submit-merchant-kyc`, formDataToSend, {
        headers: {
          'Authorization': token,
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.status === '2000') {
        toast.update(id, {
          render: response.data.description,
          type: 'success'
        });
        window.location.href = '/merchant-kyc-status';
        // Reset form
        setFormData({
          certificate: '',
          nin: '',
          file: null
        });
        setPreviewUrl(null);
      } else {
        toast.update(id, {
          render: response.data.description,
          type: 'error'
        });
      }
    } catch (error) {
      toast.update(id, {
        render: error.response?.data?.description || 'An error occurred while submitting KYC',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      <div className="row">
        <div className="col-12 col-lg-8 col-xl-8 mx-auto">
          <div className="card radius-10">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <h6 className="mb-0">Merchant KYC Verification</h6>
              </div>
              <div className="mt-4">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Certificate type</label>
                    <input
                      type="text"
                      className="form-control"
                      name="certificate"
                      value={formData.certificate}
                      onChange={handleInputChange}
                      placeholder="Enter your certificate type"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">NIN (National Identification Number)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nin"
                      value={formData.nin}
                      onChange={handleInputChange}
                      placeholder="Enter your NIN"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Upload Document</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                      accept=".jpg,.jpeg,.png,.pdf"
                    />
                    <small className="text-muted">
                      Accepted formats: JPG, JPEG, PNG, PDF (Max size: 5MB)
                    </small>
                  </div>

                  {previewUrl && (
                    <div className="mb-3">
                      <label className="form-label">Preview</label>
                      <div className="mt-2">
                        <img
                          src={previewUrl}
                          alt="Preview"
                          style={{ maxWidth: '100%', maxHeight: '200px' }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary px-4"
                      disabled={loading}
                    >
                      {loading ? 'Submitting...' : 'Submit KYC'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MerchantKYC;